import { norppa } from '../data/content';
import { FaAndroid, FaApple } from 'react-icons/fa';
import { useState, useEffect, useRef } from 'react';
import usePageMeta from '../hooks/usePageMeta';

const screenshots = {
  '/screenshots/sanaristikko-suomeksi.png': 'Suomalainen sanaristikko Norppa-sovelluksessa',
  '/screenshots/sanailu-wordle-suomeksi.png': 'Sanailu wordle suomeksi - Norppa-sovellus',
  '/screenshots/norppa-paavaliko.png': 'Norppa-sovelluksen päävalikko - ristikot ja sanailu',
  '/screenshots/ristikkoarkisto.png': 'Ristikkoarkisto - satoja suomenkielisiä ristikoita',
};
const desktopScreenshots = ['/screenshots/sanaristikko-suomeksi.png', '/screenshots/sanailu-wordle-suomeksi.png', '/screenshots/norppa-paavaliko.png'];
const mobileScreenshots = [...desktopScreenshots, '/screenshots/ristikkoarkisto.png'];

export default function Home() {
  usePageMeta({
    title: 'Norppa - Sanaristikot suomeksi',
    description: 'Norppa on ristikkopeli, joka tuo klassisen sanaristikon älypuhelimeesi. Ratkaise satoja ristikoita missä ja milloin vain! Satoja suomenkielisiä ristikoita.',
    canonical: 'https://pulmakivi.fi/',
  });

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const touchStart = useRef(0);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 640);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const handleTouch = (e, isEnd) => {
    if (!isEnd) return touchStart.current = e.touches[0].clientX;
    const diff = touchStart.current - e.changedTouches[0].clientX;
    const screenshots = isMobile ? mobileScreenshots : desktopScreenshots;
    if (Math.abs(diff) > 50) {
      setCurrentIndex((prev) => {
        const next = prev + (diff > 0 ? 1 : -1);
        return (next + screenshots.length) % screenshots.length;
      });
    }
  };

  const getClass = (i) => {
    if (!isMobile) return 'screenshot';
    const d = (i - currentIndex + mobileScreenshots.length) % mobileScreenshots.length;
    return `screenshot${d === 0 ? ' screenshot--center' : d === 1 ? ' screenshot--right' : d === mobileScreenshots.length - 1 ? ' screenshot--left' : ' screenshot--hidden'}`;
  };

  return (
    <div className="hero">
      <div className="hero__header">
        <img src="/appicon_hd.png" alt="Norppa ristikkopeli - sovelluskuvake" className="hero__app-icon" />
        <div className="hero__header-text">
          <h1 className="hero__title">{norppa.name}</h1>
          <p className="hero__tagline">{norppa.tagline}</p>
        </div>
      </div>

      <a href={norppa.googlePlayUrl} target="_blank" rel="noopener noreferrer" className="hero__google-play">
        <img src="/GetItOnGooglePlay_Badge_Web_color_Finnish.png" alt="Lataa Google Playsta" />
      </a>

      <p className="hero__description">{norppa.description}</p>

      <div className="screenshots-section">
        <div className="screenshots" onTouchStart={handleTouch} onTouchEnd={(e) => handleTouch(e, true)}>
          {(isMobile ? mobileScreenshots : desktopScreenshots).map((src, i) => (
            <img key={i} src={src} alt={screenshots[src]} className={getClass(i)} />
          ))}
        </div>
      </div>

      <ul className="features">
        {norppa.features.map((feature, i) => (
          <li key={i}>{feature}</li>
        ))}
      </ul>

      <div className="platforms">
        <div className="platform platform--available">
          <FaAndroid className="platform__icon" />
          <span className="platform__text">{norppa.platforms.android}</span>
        </div>
        <div className="platform platform--coming">
          <FaApple className="platform__icon" />
          <span className="platform__text">{norppa.platforms.ios}</span>
        </div>
      </div>
    </div>
  );
}
